export function IconMessage() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 4H20V16H6L4 18V4Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="10" r="1" fill="#000000" />
      <circle cx="12" cy="10" r="1" fill="#000000" />
      <circle cx="15" cy="10" r="1" fill="#000000" />
    </svg>
  );
}

export function IconMessageNew({
  width = 30,
  height = 30,
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 4H20V16H6L4 18V4Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="10" r="1" fill="#000000" />
      <circle cx="12" cy="10" r="1" fill="#000000" />
      <circle cx="15" cy="10" r="1" fill="#000000" />
    </svg>
  );
}
